/**
 * お問い合わせフォーム：JS バリデーション（HTML5 チェックは使用しない）
 */
const MESSAGES = {
	purpose: 'ご希望の目的を選択してください。',
	service: '検討中のサービスを選択してください。',
	company: '会社名を入力してください。',
	name: 'お名前を入力してください。',
	email_empty: 'メールアドレスを入力してください。',
	email_invalid: '正しいメールアドレスを入力してください。',
	body: 'お問い合わせ内容を入力してください。',
	privacy_agree: '個人情報の取り扱いに同意してください。',
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function showError(form, name, message) {
	const el = form.querySelector(`[data-contact-error="${name}"]`);
	const field = form.querySelector(`[data-contact-field="${name}"]`);
	if (el) {
		el.textContent = message;
		el.hidden = false;
	}
	if (field) {
		const input = field.querySelector('input, textarea') || field.querySelector('input[name="' + name + '"]');
		if (input) input.setAttribute('aria-invalid', 'true');
	}
}

function clearError(form, name) {
	const el = form.querySelector(`[data-contact-error="${name}"]`);
	const field = form.querySelector(`[data-contact-field="${name}"]`);
	if (el) {
		el.textContent = '';
		el.hidden = true;
	}
	if (field) {
		const input = field.querySelector('input, textarea') || field.querySelector('input[name="' + name + '"]');
		if (input) input.setAttribute('aria-invalid', 'false');
	}
}

function clearAllErrors(form) {
	form.querySelectorAll('[data-contact-error]').forEach((el) => {
		el.textContent = '';
		el.hidden = true;
	});
	form.querySelectorAll('[data-contact-field] input, [data-contact-field] textarea').forEach((input) => {
		input.setAttribute('aria-invalid', 'false');
	});
}

function validate(form) {
	clearAllErrors(form);

	let firstInvalid = null;

	// ご希望の目的（いずれか選択されていれば OK）
	const purpose = form.querySelector('input[name="purpose"]:checked');
	if (!purpose) {
		showError(form, 'purpose', MESSAGES.purpose);
		if (!firstInvalid) firstInvalid = form.querySelector('input[name="purpose"]');
	}

	// 検討中のサービス
	const service = form.querySelector('input[name="service"]:checked');
	if (!service) {
		showError(form, 'service', MESSAGES.service);
		if (!firstInvalid) firstInvalid = form.querySelector('input[name="service"]');
	}

	// 会社名
	const company = (form.querySelector('input[name="company"]')?.value ?? '').trim();
	if (company === '') {
		showError(form, 'company', MESSAGES.company);
		if (!firstInvalid) firstInvalid = form.querySelector('input[name="company"]');
	}

	// お名前
	const name = (form.querySelector('input[name="name"]')?.value ?? '').trim();
	if (name === '') {
		showError(form, 'name', MESSAGES.name);
		if (!firstInvalid) firstInvalid = form.querySelector('input[name="name"]');
	}

	// メールアドレス
	const email = (form.querySelector('input[name="email"]')?.value ?? '').trim();
	if (email === '') {
		showError(form, 'email', MESSAGES.email_empty);
		if (!firstInvalid) firstInvalid = form.querySelector('input[name="email"]');
	} else if (!EMAIL_REGEX.test(email)) {
		showError(form, 'email', MESSAGES.email_invalid);
		if (!firstInvalid) firstInvalid = form.querySelector('input[name="email"]');
	}

	// お問い合わせ内容
	const body = (form.querySelector('textarea[name="body"]')?.value ?? '').trim();
	if (body === '') {
		showError(form, 'body', MESSAGES.body);
		if (!firstInvalid) firstInvalid = form.querySelector('textarea[name="body"]');
	}

	// 個人情報同意
	const privacyCheckbox = form.querySelector('input[name="privacy_agree"]');
	if (!privacyCheckbox?.checked) {
		showError(form, 'privacy_agree', MESSAGES.privacy_agree);
		if (!firstInvalid) firstInvalid = privacyCheckbox;
	}

	if (firstInvalid) {
		firstInvalid.focus({ preventScroll: false });
		return false;
	}
	return true;
}

function init() {
	// バリデーションはお問い合わせ入力フォームのみ（確認ページの送信フォームには適用しない）
	const form = document.querySelector('.contactForm__form[action="/contact/confirm/index.php"]');
	if (!form) return;

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		if (!validate(form)) return;
		form.submit();
	});

	// 入力時にその項目のエラーをクリア
	form.querySelectorAll('input, textarea').forEach((input) => {
		const name = input.getAttribute('name');
		if (!name) return;
		const errorName = name === 'purpose' ? 'purpose' : name === 'service' ? 'service' : name;
		input.addEventListener('input', () => clearError(form, errorName));
		input.addEventListener('change', () => clearError(form, errorName));
	});
}

export { init as contactFormInit };
